import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';
import InfoIcon from '../InfoIcon';

export default class ItemDetailsList extends Component {

    render() {
        const {tags} = this.props;

        const canLoot = tags.indexOf('Bind on Equip') >= 0;
        const canCraft = tags.indexOf('Craftable') >= 0;
        const canBuy = tags.indexOf('Purchasable') >= 0;
        const fromQuest = tags.indexOf('Quest Reward') >= 0;

        return (
            <List horizontal divided>
                <List.Item>
                    <InfoIcon icon="coins" isEnabled={canBuy} tooltip='This item is sold by a vendor' />
                </List.Item>
                <List.Item>
                    <InfoIcon icon="wrench" isEnabled={canCraft} tooltip='This item is craftable' />
                </List.Item>
                <List.Item>
                    <InfoIcon icon="hand-rock" isEnabled={canLoot} tooltip='This item is bind on equip' />
                </List.Item>
                <List.Item>
                    <InfoIcon icon="check-circle" isEnabled={fromQuest} tooltip='This item is a quest reward' />
                </List.Item>
            </List>
        )
    }
};

ItemDetailsList.propTypes = {
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
};


// WEBPACK FOOTER //
// ./src/common/items/ItemDetailsList.jsx